import { useEffect, useRef, useState } from 'react';
import { ProTableOt, Row, Col, Button, useProTableOt, useCRUDController, Tag } from '../../ui/ot'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next';

const ScrappedListProgressTable = ({
    rowKey = 'library_task_id',
    keyPrefix = "library.backstage.Circulation.CheckOut.borrowed_list",
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const actionRef = useRef()
    const columns = [
        {
            title: '更新結果',
            dataIndex: 'task_explaination',
            key: 'task_explaination',
            render: (text, record, index) => {

                if (text === "更新失敗") {
                    return <Row justify="center">
                        <Col>
                            <Tag color="error"> {text}</Tag>
                        </Col>
                    </Row>
                }
                else if (text === "進行中") {
                    return <Row justify="center">
                        <Col>
                            <Tag color="blue">{text} </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col> <Tag color="success">{text} </Tag></Col>
                    </Row>

                }

            }
        },
        {
            title: '清單名稱',
            dataIndex: 'task_name',
            key: 'task_name',
        },
        {
            title: '更新時間',
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: '完成時間',
            dataIndex: 'end_time',
            key: 'end_time',
        },
    ];
    const scrappedListImportProgressController = useCRUDController({ apiRoute: "/library/scrapped_list/progress" })
    const setParamsFilter = (obj) => {
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })

    return <>
        <ProTableOt
            actionRef={actionRef}
            columns={columns}
            check={check}
            setCheck={setCheck}
            rowKey={rowKey}
            request={async (params = {}, sort, filter) => {
                // setAxiosMode("get")
                let newParams = {

                };
                let order = setOrders(sort)
                newParams = {
                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    order,
                    size: params.pageSize,
                    cur_page: params.current,
                    custom_filter_value: params.keyword ?? "",
                    custom_filter_key: custom_filter_key,
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                // setPageSize(params?.pageSize ?? 20)
                return scrappedListImportProgressController.getData({
                    ...newParams
                })
            }}
            rowSelection={false}
        />
    </>
}
export default ScrappedListProgressTable
